import styled from 'styled-components'

export const CarouselStackStyled = styled.div`
  display: grid;
  width: 100%;
`
